<template>
  <div class="targeting-info">
    <completion-indicator :percent="fillPercentage" :showClose="false" />
    <targeting-info-description />
    <targeting-info-form />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CompletionIndicator from '@/components/account/targetingInfo/CompletionIndicator.vue';
import TargetingInfoForm from '@/components/account/targetingInfo/TargetingInfoForm.vue';
import TargetingInfoDescription from '@/components/account/targetingInfo/TargetingInfoDescription.vue';

export default {
  components: {
    CompletionIndicator,
    TargetingInfoForm,
    TargetingInfoDescription,
  },
  computed: {
    ...mapGetters(['fillPercentage']),
  },
};
</script>

<style lang="scss" scoped>
.targeting-info {
  flex: 1;
}
span {
  letter-spacing: 0.11px;
  line-height: 18px;
}
</style>
